/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kpi_Overflow_VolumeInputs */

const en_us2_kpi_overflow_volume = /** @type {(inputs: Kpi_Overflow_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overflow volume`)
};

const en_gb2_kpi_overflow_volume = /** @type {(inputs: Kpi_Overflow_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spill volume`)
};

/**
* | output |
* | --- |
* | "Overflow volume" |
*
* @param {Kpi_Overflow_VolumeInputs} inputs
* @param {{ locale?: "en-US" | "en-GB" }} options
* @returns {LocalizedString}
*/
export const kpi_overflow_volume = /** @type {((inputs?: Kpi_Overflow_VolumeInputs, options?: { locale?: "en-US" | "en-GB" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kpi_Overflow_VolumeInputs, { locale?: "en-US" | "en-GB" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en-GB") return en_gb2_kpi_overflow_volume(inputs)
	return en_us2_kpi_overflow_volume(inputs)
});